export default function generateConfigPlayer(idDiv, idVideo) {
  const tppxDataPlayer = {
    sizes: [[9, 9]], // 9x9 es el tamaño para los vídeos instream // [[630, 555]],
    autoplay: false,
    muted: false,
    volume: 1,
    debug: true,
    targetId: idDiv,
    template: 0,
    theme: 'playon',
    loop: false,
    numAdsPos: 1,
    numAdsPre: 1,
    numAdsMid: 0,
    timesMidroll: [25],
    endpoint: 'js42380pl',
    showControls: true,
    tappxKey: {
      mweb: 'pub-78631-mweb-1049',
      desktop: 'pub-78632-desktop-1088',
    },
    code: 'tppx_300250',
    service: 'POC',
    poc: { idVideo, service: 'directYoutube', idPub: 13444 },
  };

  return tppxDataPlayer;
}
